<template>
  <div
    class="min-w-0 rounded-md bg-lightSecondaryBackgroundColor p-lg shadow-sm dark:bg-darkSecondaryBackgroundColor dark:shadow-none print:bg-lightSecondaryBackgroundColor print:p-0 print:shadow-none"
    v-bind="$attrs"
  >
    <slot />
  </div>
</template>
